import React, { useEffect } from 'react';

const AmazonStockWidget = () => {
  useEffect(() => {
    // Check if the script is already loaded to prevent duplicates
    if (!document.getElementById('tradingview-widget-script')) {
      const script = document.createElement('script');
      script.id = 'tradingview-widget-script';
      script.src = "https://s3.tradingview.com/external-embedding/embed-widget-symbol-info.js";
      script.async = true;
      script.innerHTML = JSON.stringify({
        symbol: "NASDAQ:AMZN",
        width: 550,
        locale: "en",
        colorTheme: "dark",
        isTransparent: true,
      });
      document.getElementById("tradingview-widget-container").appendChild(script);
    }
  }, []);

  return (
    <>
    
    <div className="tradingview-widget-container" id="tradingview-widget-container">
      <div className="tradingview-widget-container__widget"></div>
      <div className="tradingview-widget-copyright">
        <a href="https://www.tradingview.com/" rel="noopener nofollow" target="_blank">
        </a>
      </div>
    </div>
    <button onClick={() => {alert("Your account is not yet activated to use the live trading portal")}} style={{margin:"1.5rem"}}>Start Live Trading</button>
    </>
  );
};

export default AmazonStockWidget;
